import gql from 'graphql-tag';

const UPDATE_ORG_THEME_CONFIG = gql`
  mutation updateOrgTheme(
    $id: ID!
    $primaryColor: String
    $sidebarColor: String
    $sidebarIsGradient: Boolean
    $sidebarGradientStart: String
    $sidebarGradientEnd: String
  ) {
    updateOrgTheme(
      where: { id: $id }
      data: {
        primaryColor: $primaryColor
        sidebarColor: $sidebarColor
        sidebarIsGradient: $sidebarIsGradient
        sidebarGradientStart: $sidebarGradientStart
        sidebarGradientEnd: $sidebarGradientEnd
      }
    ) {
      primaryColor
      sidebarColor
      sidebarIsGradient
      sidebarGradientStart
      sidebarGradientEnd
    }
  }
`;

export default UPDATE_ORG_THEME_CONFIG;
